export default "__VITE_ASSET__JkdavTX2__"